import axios from "axios";
import { UserService } from './user';
import { CheckLibs } from '../libs/check';
import { UniDataService } from './datauni';
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    let token = UserService.token(true);
    !config.headers && (config.headers = {});
    config.headers.Authorization = token;
    config.headers.tokenType = 'jrzz';
    return config;
});
async function origin_ajax(_type, _url, _params = {}, _options = {}) {
    try {
        // @ts-ignore
        return await axios[_type](_url, _params, _options);
    }
    catch (response) {
        throw response;
    }
}
async function ajax(_type, _url, _params = {}, _options = {}) {
    let result = await origin_ajax(_type, _url, _params, _options);
    return result.data;
}
export class DataService {
    static async get(_url, _params = {}, _options = {}) {
        // @ts-ignore
        if (CheckLibs.isUniApp()) {
            return await UniDataService.get(_url, _params, _options);
        }
        return await ajax("get", _url, Object.assign({ params: _params }, _options));
    }
    static async post(_url, _params = {}, _options = {}) {
        // @ts-ignore
        if (CheckLibs.isUniApp()) {
            return await UniDataService.post(_url, _params, _options);
        }
        return await ajax("post", _url, _params, _options);
    }
}
